import axios from "axios";

const BASE_URL = process.env.APP_BASE_URL || 'https://apiv3.edustack360.com';

const baseapi = axios.create({
    baseURL: BASE_URL,
});

baseapi.interceptors.request.use((config)=>{

    //const token = sessionStorage.getItem('cpmstoken');
    const token = localStorage.getItem('cpmstoken');

    if(token)
    {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
},
(error) => Promise.reject(error)
);

export default baseapi;